"use client";

/**
 * Tarjeta de producto del rediseño (grid de 2 columnas).
 * Cabecera de gradiente + chip 210 g + corazón, texto y botón "Agregar".
 */

import { useState } from "react";
import { useRouter } from "next/navigation";

import { useApp } from "./proveedor";
import { FotoBoot } from "./foto-boot";
import { IconoCorazon, IconoMas } from "./iconos";
import { PrecioDist } from "./precio-dist";
import { SelectorPresentacion } from "./selector-presentacion";
import type { ProductoApp } from "./tipos";

export function ProductoCard({
  producto,
  conFavorito = true,
}: {
  producto: ProductoApp;
  conFavorito?: boolean;
}) {
  const router = useRouter();
  const { favoritos, toggleFavorito, descuentoDist } = useApp();
  const [eligiendo, setEligiendo] = useState(false);
  const esFav = Boolean(favoritos[producto.slug]);

  return (
    <div className="relative h-[286px] overflow-hidden rounded-[30px] bg-white shadow-card">
      <button
        type="button"
        aria-label={`Ver ${producto.nombre}`}
        onClick={() => router.push(`/productos/${producto.slug}`)}
        className="relative block h-[153px] w-full cursor-pointer overflow-hidden rounded-t-[30px] rounded-b-2xl"
        style={{ background: producto.gradiente }}
      >
        {producto.imagen ? (
          <FotoBoot
            imagen={producto.imagen}
            gradiente={producto.gradiente}
            alt={producto.nombre}
            sizes="(max-width: 430px) 50vw, 210px"
          />
        ) : (
          <span className="absolute top-[34px] left-1/2 h-[86px] w-16 -translate-x-1/2 rounded-[14px] border border-white/50 bg-white/30 backdrop-blur-[2px]" />
        )}
        <span className="absolute top-3 left-3 rounded-[20px] bg-white/90 px-2.5 py-1 text-[11px] font-bold text-tinta">
          210 g
        </span>
      </button>
      {conFavorito && (
        <button
          type="button"
          aria-label={esFav ? "Quitar de favoritos" : "Guardar en favoritos"}
          onClick={() => toggleFavorito(producto.slug)}
          className="absolute top-2.5 right-2.5 flex h-7 w-7 items-center justify-center rounded-full bg-white/90"
        >
          <IconoCorazon color="#221F1F" relleno={esFav ? "#A8DB3A" : "none"} />
        </button>
      )}
      <div className="px-3.5 pt-3">
        <div className="text-[11px] font-medium tracking-[.06em] text-tinta/50 uppercase">
          {producto.categoria}
        </div>
        <div className="mt-1 h-5 overflow-hidden text-sm leading-[18px] text-tinta">
          {producto.nombre}
        </div>
        <div className="mt-[3px] font-app text-[17px] font-semibold text-black">
          <PrecioDist
            precio={producto.precio}
            descuento={descuentoDist}
            claseTachado="text-[13px]"
          />
        </div>
      </div>
      <button
        type="button"
        onClick={() => setEligiendo(true)}
        className="absolute bottom-2 left-3.5 flex h-9 w-[calc(100%-28px)] items-center justify-center gap-1.5 rounded-[20px] bg-lima font-app text-sm font-semibold text-bosque transition active:scale-[.96]"
      >
        <IconoMas color="#082411" />
        Agregar
      </button>
      <SelectorPresentacion
        producto={producto}
        abierto={eligiendo}
        onCerrar={() => setEligiendo(false)}
      />
    </div>
  );
}
